import React from 'react';
import { useStyles } from './ChatMessage.styles';
import playButtonImg from '../../img/playButton.svg';
import stopButtonImg from '../../img/stopButton.svg';

const ChatMessage = ({ message, image, modelName, handlePlayButtonClick, handleStopButtonClick, isPlaying, isSendBlocked, isAnimating }) => {
  const classes = useStyles();
  const isUser = message.role === 'user';

  return (
    <div className={isUser ? classes.userMessageContainer : classes.assistantMessageContainer}>
      {!isUser && (
        <>
          <img src={image} alt={modelName} className={classes.avatar} />
          <div className={classes.assistantMessageWrapper}>
          <div className={classes.header}>
            <span className={classes.modelName}>{modelName}</span>
            <div className={classes.buttonWithBars}>
              <button
                onClick={isPlaying && isAnimating ? handleStopButtonClick : handlePlayButtonClick}
                className={classes.playButton}
                disabled={isSendBlocked}
              >
                {isPlaying && isAnimating ? (
                  <img src={stopButtonImg} alt="Stop Icon" />
                ) : (
                  <img src={playButtonImg} alt="Play Icon" className={classes.playIcon} />
                )}
              </button>
              {isPlaying && isAnimating && (
                <div className={classes.bars}>
                  <div className={classes.bar}></div>
                  <div className={classes.bar}></div>
                  <div className={classes.bar}></div>
                </div>
              )}
            </div>
          </div>
            <div className={classes.assistantMessage}>{message.content}</div>
          </div>
        </>
      )}
      {isUser && <div className={classes.userMessage}>{message.content}</div>}
    </div>
  );
};

export default ChatMessage;
